import { __assign, __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { BrandclubPageType } from '@brandclub/types';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { styled, Grid } from '@mui/material';
import numeral from 'numeral';
import pluralize from 'pluralize';
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { FreeMode, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../analytics/AnalyticsService.js';
import 'branch-sdk';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import '../../analytics/metaPixel.js';
import '../../analytics/fingerprint.js';
import { BuyBoxType } from '../../Components/BuyBoxDialog/BuyBoxType.js';
import { ProductPrice } from '../../Components/BuyBoxDialog/ProductPrice.js';
import { ArrowCircleRightIcon } from '../../icons/ArrowCircleRightIcon.js';
import { CampaignType } from '../../types/Campaign.js';
import { trackRetailerProductPageEvent } from '../../utils/analytics.js';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { useDebouncedCallback } from '../../utils/hooks/useDebouncedCallback.js';
import { getProductPageRewards, getSortedBuyBoxProducts, isProductOutOfStock } from '../../utils/productUtils.js';
import { decodeHTMLCharacters, changeAmazonImageUrlResolution, formatMoney, getRetailerFromId } from '../../utils/stringUtils.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import { BuyBoxDialog } from '../BuyBoxDialog/index.js';
import { BrandclubBreadcrumbs } from '../components/BrandclubBreadcrumbs/BrandclubBreadcrumbs.js';
import { BrandclubVideo } from '../components/BrandclubVideo.js';
import { GenericContainer } from '../components/GenericContainer.js';
import ShareIcon from '../components/Icons/ShareIcon.js';
import { ProductPageDialog } from '../components/ProductPageDialog/ProductPageDialog.js';
import { RewardPillWithText } from '../components/RewardPill/RewardPillWithText.js';

var PopularProductsContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 30,
            paddingBottom: 50,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "0 0 ".concat(WIDGET_SPACE_HALF, "px 0"),
        },
        _b);
});
var ContentWrapper = styled(Grid)(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var theme = _a.theme;
    return (_b = {
            maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
            width: '100%',
            flexDirection: 'row'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            flexDirection: 'column',
        },
        _b.img = {},
        _b['.product_images_desktop'] = (_c = {
                display: 'flex',
                flex: 1
            },
            _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'none',
            },
            _c['.thumbs'] = {
                '.swiper-button-prev': {
                    display: 'none',
                },
                '.swiper-button-next': {
                    display: 'none',
                },
                '.thumb': {
                    borderRadius: '3px',
                    width: '67px',
                    height: '67px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    img: {
                        maxWidth: '100%',
                        maxHeight: '100%',
                    },
                },
            },
            _c['.preview'] = {
                width: '100%',
                maxHeight: '610px',
                maxWidth: '650px',
                marginLeft: '35px',
                display: 'flex',
                aspectRatio: '13/10',
                justifyContent: 'center',
                alignItems: 'flex-start',
                backgroundPosition: '50%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                overflow: 'hidden',
                borderRadius: 2,
                img: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                },
            },
            _c),
        _b['.product_images_mobile'] = (_d = {
                width: '100vw',
                height: '100vw',
                display: 'none',
                paddingTop: 30
            },
            _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                display: 'flex',
                flexDirection: 'column',
            },
            _d['.preview'] = {
                aspectRatio: '13/10',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                img: {
                    maxWidth: '100%',
                    maxHeight: '100vw',
                },
            },
            _d['.swiper'] = { width: '100%', height: '100%' },
            _d['.swiper-slide'] = {
                textAlign: 'center',
                fontSize: '18px',
                background: '#fff',
                display: ['-webkit-box', '-ms-flexbox', '-webkit-flex', 'flex'],
                WebkitBoxPack: 'center',
                msFlexPack: 'center',
                WebkitJustifyContent: 'center',
                justifyContent: 'center',
                WebkitBoxAlign: 'center',
                msFlexAlign: 'center',
                WebkitAlignItems: 'center',
                alignItems: 'center',
            },
            _d['.swiper-pagination-fraction'] = {
                display: 'flex',
                justifyContent: 'flex-end',
                right: '20px',
                left: 'unset',
                color: '#fff',
                fontFamily: 'Poppins',
                '>div': {
                    backgroundColor: '#0000006e',
                    borderRadius: 5,
                    padding: '3px 7px',
                    fontSize: '12px',
                    fontWeight: 600,
                },
            },
            _d['.swiper-pagination-bullet-active'] = {
                backgroundColor: theme.palette.primary.main,
            },
            _d),
        _b['.product_info'] = (_e = {
                display: 'flex',
                flexDirection: 'column',
                gap: 9,
                margin: '0 0 30px 0'
            },
            _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                padding: "0 ".concat(TABLET_HORIZONTAL_PADDING, "px"),
                margin: '20px 0 20px 0',
            },
            _e["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                padding: "0 ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
            },
            _e['.path'] = {
                fontSize: 14,
                fontWeight: 600,
            },
            _e['.review'] = {
                fontSize: 14,
                fontWeight: 600,
            },
            _e['.product_name'] = (_f = {
                    fontSize: 24,
                    fontWeight: 600,
                    width: '100%',
                    lineHeight: 1.4,
                    boxSizing: 'border-box'
                },
                _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                    fontSize: 20,
                    fontWeight: 600,
                    width: '100%',
                    lineHeight: 1.5,
                    display: 'block',
                },
                _f),
            _e),
        _b['&.main_product_body'] = (_g = {
                display: 'grid',
                gridTemplateColumns: 'auto 483px',
                gap: 42
            },
            _g["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = { display: 'flex', gap: 0 },
            _g),
        _b);
});
var Details = styled('div')(function (_a) {
    var _b, _c, _d, _e, _f;
    var theme = _a.theme;
    return (_b = {
            border: '1px solid #ebeef2',
            borderRadius: 5,
            boxSizing: 'border-box',
            height: 'fit-content',
            width: '100%'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            border: 'none',
            width: '100%',
            padding: "0 ".concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            border: 'none',
            width: '100%',
            padding: "0 ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b['.brand_link'] = {
            color: theme.palette.primary.main,
            fontSize: '16px',
            fontWeight: 600,
            marginBottom: '6px',
            textDecoration: 'none',
        },
        _b['.product_price'] = (_c = {
                padding: '40px 35px'
            },
            _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                padding: '40px 0',
                paddingTop: 0,
            },
            _c.display = 'flex',
            _c.flexDirection = 'column',
            _c.gap = 40,
            _c['.price_card'] = {
                display: 'flex',
                '.retailer_icon': {
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px',
                    img: {
                        maxWidth: '100%',
                        maxHeight: '100%',
                    },
                },
                '.retailer_price': {
                    flex: 1,
                    div: {
                        width: 'fit-content',
                    },
                    '.name': {
                        fontSize: 14,
                        fontWeight: 600,
                    },
                    '.price': (_d = {
                            fontSize: 24,
                            fontWeight: 600
                        },
                        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                            fontSize: 22,
                        },
                        _d),
                },
            },
            _c),
        _b['.product_join'] = (_e = {
                padding: '25px 35px',
                borderTop: '1px solid #ebeef2',
                display: 'flex',
                justifyContent: 'space-between',
                gap: '30px',
                flexDirection: 'row',
                alignItems: 'center',
                cursor: 'pointer',
                img: { width: 50 }
            },
            _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                padding: '40px 0',
                borderBottom: '1px solid #ebeef2',
            },
            _e['.desc'] = (_f = {
                    fontSize: '16px',
                    fontWeight: 500,
                    width: '100%',
                    maxWidth: 270
                },
                _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                    marginRight: 10,
                    textAlign: 'left',
                },
                _f),
            _e),
        _b);
});
var ProductDetails = function (_a) {
    var _b, _c;
    var title = _a.title, shortTitle = _a.shortTitle, images = _a.images, videos = _a.videos, mainEntity = _a.mainEntity, brandEntity = _a.brandEntity, brandclub = _a.brandclub, axios = _a.axios, analyticsTrack = _a.analyticsTrack, trackingParams = _a.trackingParams, LinkComponent = _a.LinkComponent, persistentQueryParams = _a.persistentQueryParams, retailers = _a.retailers, routePrefix = _a.routePrefix, onShareClick = _a.onShareClick, onAddToCart = _a.onAddToCart;
    var entity = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity;
    var _d = useState(0), selectImage = _d[0], setSelectImage = _d[1];
    var _e = useState(entity), claimedProduct = _e[0], setClaimProduct = _e[1];
    var _f = useState(false), purchaseRewardPopupOpen = _f[0], setPurchaseRewardPopupOpen = _f[1];
    var _g = useState(), retailerPDPNavParams = _g[0], setRetailerPDPNavParams = _g[1];
    var _h = useState(false), showBuyBoxFooter = _h[0], setShowBuyBoxFooter = _h[1];
    var _j = useState(showBuyBoxFooter ? BuyBoxType.BuyBoxBottomSheetShort : undefined), buyBoxFooterType = _j[0], setBuyBoxFooterType = _j[1];
    var isMobile = useCallback(function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator === null || navigator === void 0 ? void 0 : navigator.userAgent);
    }, []);
    var titleToUse = shortTitle || title || (entity === null || entity === void 0 ? void 0 : entity.title) || '';
    var refinedProductTitle = decodeHTMLCharacters(titleToUse);
    var rewards = useMemo(function () {
        return getProductPageRewards({ productEntity: entity, brandEntity: brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity, brandclub: brandclub, retailers: retailers });
    }, [mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity, brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity, brandclub, retailers]);
    var productsToList = [
        __assign({}, entity),
    ];
    var affiliateRewardAmount = (_b = rewards.find(function (reward) { return reward.rewardType === CampaignType.AffiliateRewardCampaign; })) === null || _b === void 0 ? void 0 : _b.rewardAmount;
    (_c = entity.matchedProducts) === null || _c === void 0 ? void 0 : _c.forEach(function (matchedProduct) {
        productsToList.push(__assign({}, matchedProduct));
    });
    // debounce the scroll event analytics tracking to once every 2 second
    var analyticsTrackScroll = useDebouncedCallback(function () {
        if (window.scrollY < 50) {
            return;
        }
        var widgetParams = {
            pageType: BrandclubPageType.Product,
            pageId: entity.stacklineSku,
            retailerId: entity.retailerId,
            retailerSku: entity.retailerSku,
            stacklineSku: entity.stacklineSku,
            title: title,
        };
        analyticsTrack === null || analyticsTrack === void 0 ? void 0 : analyticsTrack(AnalyticsTrackingEvent.WEB_APP_PRODUCT_PAGE_SCROLL, __assign(__assign(__assign({}, trackingParams), widgetParams), { scrollY: window.scrollY }));
    }, 2000);
    var handleScroll = useCallback(function () {
        analyticsTrackScroll();
        if (!isMobile()) {
            return;
        }
        if (window.scrollY >= 500 + 100 * ((productsToList === null || productsToList === void 0 ? void 0 : productsToList.length) || 1)) {
            setShowBuyBoxFooter(true);
            if (!buyBoxFooterType) {
                setBuyBoxFooterType(BuyBoxType.BuyBoxBottomSheetShort);
            }
        }
        else {
            setShowBuyBoxFooter(false);
        }
    }, []);
    useEffect(function () {
        window.addEventListener('scroll', handleScroll);
        // do it on load once
        handleScroll();
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [productsToList === null || productsToList === void 0 ? void 0 : productsToList.length]);
    var previews = [];
    var previewImages = [];
    var previewVideos = [];
    for (var i = 0; i < images.length; i++) {
        // read from entity if propValue is empty string
        var imageToUse = '';
        if (images[i]) {
            imageToUse = images[i];
        }
        else if (i < ((entity === null || entity === void 0 ? void 0 : entity.imageUrls) || []).length && entity.imageUrls[i]) {
            imageToUse = entity.imageUrls[i];
        }
        if (imageToUse) {
            previews.push({ type: 'image', image: imageToUse });
            previewImages.push(imageToUse);
        }
    }
    for (var i = 0; videos && i < videos.length; i++) {
        if (videos[i].video && videos[i].coverImage) {
            previews.push({ type: 'video', video: videos[i].video, image: videos[i].coverImage });
            previewVideos.push({ type: 'video', video: videos[i].video, coverImage: videos[i].coverImage });
        }
    }
    var categoryRoute = "".concat(routePrefix, "/categories/").concat(entity === null || entity === void 0 ? void 0 : entity.categoryId, "?").concat(persistentQueryParams || '');
    var subCategoryRoute = "".concat(routePrefix, "/subcategories/").concat(entity === null || entity === void 0 ? void 0 : entity.subCategoryId, "?").concat(persistentQueryParams || '');
    var currentPreview = selectImage < previews.length ? previews[selectImage] : {};
    var handlePurchaseRewardPopupClose = function () { return setPurchaseRewardPopupOpen(false); };
    var handleSendText = function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, sendTextCallback(phoneNumber, axios, brandEntity, analyticsTrack, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK)];
        });
    }); };
    var trackBuyClick = function (_a) {
        var trackingEventAction = _a.trackingEventAction, retailerId = _a.retailerId, retailPrice = _a.retailPrice, retailerSku = _a.retailerSku, stacklineSku = _a.stacklineSku, retailerProductPageUrl = _a.retailerProductPageUrl, title = _a.title, availabilityStatus = _a.availabilityStatus;
        if ((mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.type) === 'product' && (stacklineSku || (entity === null || entity === void 0 ? void 0 : entity.stacklineSku))) {
            var widgetParams = {
                widgetContext: 'retailerPrices',
                pageType: BrandclubPageType.Product,
                pageId: entity.stacklineSku,
                retailerUrl: retailerProductPageUrl,
                retailerId: retailerId,
                retailerSku: retailerSku,
                stacklineSku: stacklineSku !== null && stacklineSku !== void 0 ? stacklineSku : entity.stacklineSku,
                retailPrice: retailPrice,
                title: title,
                availabilityStatus: availabilityStatus,
            };
            setRetailerPDPNavParams(widgetParams);
            trackRetailerProductPageEvent({
                trackingEventAction: trackingEventAction,
                trackingParams: __assign(__assign({}, trackingParams), widgetParams),
                analyticsTrack: analyticsTrack,
            });
        }
    };
    var handleBuyClick = function (item) {
        setClaimProduct(item);
        if (onAddToCart) {
            var isOutOfStock = isProductOutOfStock(item);
            var trackingEventAction = 'addToCart';
            trackBuyClick({
                trackingEventAction: trackingEventAction,
                retailerId: item === null || item === void 0 ? void 0 : item.retailerId,
                retailPrice: item === null || item === void 0 ? void 0 : item.retailPrice,
                retailerSku: item === null || item === void 0 ? void 0 : item.retailerSku,
                stacklineSku: item === null || item === void 0 ? void 0 : item.stacklineSku,
                retailerProductPageUrl: item === null || item === void 0 ? void 0 : item.retailerProductPageUrl,
                title: item === null || item === void 0 ? void 0 : item.title,
                availabilityStatus: isOutOfStock ? 'OutOfStock' : 'InStock',
            });
            onAddToCart(__assign({}, item));
        }
        else {
            handleOpenRetailerProductPageClick(item);
        }
    };
    var handleOpenRetailerProductPageClick = function (item) {
        var isOutOfStock = isProductOutOfStock(item);
        var trackingEventAction = 'openRetailerProductPage';
        trackBuyClick({
            trackingEventAction: trackingEventAction,
            retailerId: item === null || item === void 0 ? void 0 : item.retailerId,
            retailPrice: item === null || item === void 0 ? void 0 : item.retailPrice,
            retailerSku: item === null || item === void 0 ? void 0 : item.retailerSku,
            stacklineSku: item === null || item === void 0 ? void 0 : item.stacklineSku,
            retailerProductPageUrl: item === null || item === void 0 ? void 0 : item.retailerProductPageUrl,
            title: item === null || item === void 0 ? void 0 : item.title,
            availabilityStatus: isOutOfStock ? 'OutOfStock' : 'InStock',
        });
        window.open(item.retailerProductPageUrl, '_blank');
    };
    var handleBuyBoxOpen = function () {
        return BuyBoxDialog.show({
            products: productsToList,
            onClick: handleBuyClick,
            onProductPageClick: handleOpenRetailerProductPageClick,
        });
    };
    var breadcrumbs = [
        {
            label: entity === null || entity === void 0 ? void 0 : entity.categoryName,
            to: categoryRoute,
        },
        {
            label: entity === null || entity === void 0 ? void 0 : entity.subCategoryName,
            to: subCategoryRoute,
        },
    ];
    var sortedProductList = getSortedBuyBoxProducts(productsToList);
    var extraRetailerCount = productsToList.length - 3;
    return (React.createElement(PopularProductsContainer, null,
        React.createElement(ContentWrapper, { className: "main_product_body", container: true, wrap: "nowrap" },
            React.createElement("div", { className: "product_images_desktop" },
                React.createElement("div", { className: "thumbs" },
                    React.createElement(Swiper, { direction: "vertical", freeMode: true, slidesPerView: 'auto', spaceBetween: 20, navigation: true, modules: [FreeMode, Navigation], className: "mySwiper", style: { maxHeight: '100%' } }, previews.map(function (_a, idx) {
                        var image = _a.image;
                        return (React.createElement(SwiperSlide, { key: idx },
                            React.createElement("div", { className: 'thumb', role: "button", onMouseEnter: function () {
                                    setSelectImage(idx);
                                }, onTouchEnd: function () {
                                    setSelectImage(idx);
                                } },
                                React.createElement("img", { loading: "lazy", src: changeAmazonImageUrlResolution(image, 100), alt: "preview" }))));
                    }))),
                React.createElement(React.Fragment, null, currentPreview.type === 'video' ? (React.createElement("div", { className: "preview" },
                    React.createElement(BrandclubVideo, { videoUrl: currentPreview.video, posterUrl: currentPreview.image }))) : (React.createElement("div", { className: "preview" },
                    React.createElement("img", { loading: "lazy", src: currentPreview.image, alt: "", style: { maxWidth: '100%', maxHeight: '100%' } }))))),
            React.createElement("div", { className: "product_images_mobile" },
                React.createElement(Swiper, { style: {}, pagination: {
                        type: 'fraction',
                        renderFraction: function (currentClass, totalClass) {
                            return ('<div><span class="' +
                                currentClass +
                                '"></span>' +
                                ' / ' +
                                '<span class="' +
                                totalClass +
                                '"></span></div>');
                        },
                    }, modules: [Pagination], className: "mySwiper" },
                    previewImages.slice(0, 8).map(function (imgUrl, idx) {
                        return (React.createElement(SwiperSlide, { key: idx },
                            React.createElement("div", { className: "preview" },
                                React.createElement("img", { loading: "lazy", src: imgUrl, alt: "product-image-preview" }))));
                    }),
                    previewVideos.map(function (_a, idx) {
                        var video = _a.video, coverImage = _a.coverImage;
                        return (React.createElement(SwiperSlide, { key: idx }, function (_a) {
                            var isActive = _a.isActive;
                            return (React.createElement("div", { className: "preview" },
                                React.createElement(BrandclubVideo, { videoUrl: video, posterUrl: coverImage, canPlay: isActive })));
                        }));
                    })),
                React.createElement("div", { style: { marginLeft: 'auto', right: '20px', position: 'absolute', zIndex: 1 } }, affiliateRewardAmount ? (React.createElement(RewardPillWithText, { rewardAmount: affiliateRewardAmount, rewardCampaignType: CampaignType.AffiliateRewardCampaign, containerStyle: {
                        columnGap: 11,
                    }, baseFontSize: 16, onPillClick: function (e) {
                        if (onShareClick) {
                            onShareClick(e, entity);
                        }
                    } })) : (React.createElement(Grid, { container: true, display: "flex", alignItems: "center", columnGap: "12.5px" },
                    React.createElement(ShareIcon, { imgProps: {
                            onClick: function (e) {
                                if (onShareClick) {
                                    onShareClick(e, entity);
                                }
                            },
                        } }))))),
            React.createElement("div", null,
                React.createElement("div", { className: "product_info" },
                    React.createElement("div", { className: "path" },
                        React.createElement(BrandclubBreadcrumbs, { items: breadcrumbs, LinkComponent: LinkComponent })),
                    React.createElement("div", { className: "product_name" }, refinedProductTitle),
                    React.createElement("div", { className: "review" },
                        React.createElement(Grid, { container: true, display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", flexWrap: 'nowrap' }, (entity === null || entity === void 0 ? void 0 : entity.reviewsCount) && (entity === null || entity === void 0 ? void 0 : entity.reviewsCount) > 0 ? (React.createElement(Grid, { item: true, display: "flex", alignItems: "center" },
                            React.createElement(StarRoundedIcon, { sx: { marginRight: '6px', marginBottom: '3px', fontSize: 21, color: '#ed792f' } }),
                            ' ',
                            (entity === null || entity === void 0 ? void 0 : entity.reviewsRating) || 0,
                            ' (',
                            numeral((entity === null || entity === void 0 ? void 0 : entity.reviewsCount) || 0).format("0,0"), " ".concat(pluralize('rating', (entity === null || entity === void 0 ? void 0 : entity.reviewsCount) || 0), ")"))) : null))),
                React.createElement(Details, null,
                    React.createElement(ProductPrice, { productsToList: sortedProductList, onBuyClick: handleBuyClick, onOpenRetailerProductPageClick: handleOpenRetailerProductPageClick }),
                    productsToList.length > 3 ? (React.createElement("div", { className: "product_join", onClick: handleBuyBoxOpen },
                        React.createElement("div", { className: "desc" }, "View ".concat(extraRetailerCount, " other ").concat(pluralize('retailer', extraRetailerCount), " for more ways to purchase.")),
                        React.createElement(ArrowCircleRightIcon, { backgroundColor: "primary", htmlColor: "#fff" }))) : null,
                    React.createElement(BuyBoxDialog, null),
                    showBuyBoxFooter && buyBoxFooterType ? (React.createElement(ProductPrice, { productsToList: sortedProductList, buyBoxType: buyBoxFooterType, onBuyClick: handleBuyClick, fixedPosition: true, onOpenRetailerProductPageClick: handleOpenRetailerProductPageClick, onExpandBuyBoxToggle: function () {
                            if (buyBoxFooterType === BuyBoxType.BuyBoxBottomSheetShort) {
                                setBuyBoxFooterType(BuyBoxType.BuyBoxBottomSheetExpanded);
                            }
                            else {
                                setBuyBoxFooterType(BuyBoxType.BuyBoxBottomSheetShort);
                            }
                        } })) : null))),
        React.createElement(ProductPageDialog, { popupDrawerProps: { open: purchaseRewardPopupOpen, onClose: handlePurchaseRewardPopupClose }, showIcon: true, title: "Purchase rewards", subtitle: "".concat((claimedProduct === null || claimedProduct === void 0 ? void 0 : claimedProduct.totalRewardAmount)
                ? "Earn ".concat(formatMoney(claimedProduct.totalRewardAmount), " when you purchase this product.")
                : "Earn cash rewards in purchases.", " Access rewards in the Brandclub app."), phoneInput: {
                redirectionText: "Finish and checkout on ".concat(getRetailerFromId(claimedProduct.retailerId)),
                redirectionUrl: claimedProduct.retailerProductPageUrl,
                autoRedirectOnSuccess: true,
            }, redirect: {
                text: "I already have the Brandclub app",
                url: claimedProduct.retailerProductPageUrl,
            }, trackRetailerPDPNavigation: true, retailerPDPNavigationEventParams: retailerPDPNavParams, trackingParams: trackingParams, analyticsTrack: analyticsTrack, handleSendText: handleSendText, Link: LinkComponent })));
};

export { ProductDetails };
//# sourceMappingURL=index.js.map
